import { toast } from "@shuttlerock/mui-components";
import { useTranslation } from "../i18n";

export type UseClipboardOptions = {
  successMessage?: string;
  errorMessage?: string;
};

export type UseClipboard = {
  copyToClipboard: (value: string, options?: UseClipboardOptions) => Promise<void>;
};

export const useClipboard = (): UseClipboard => {
  const { t } = useTranslation();

  const copyToClipboard = async (
    value: string,
    {
      successMessage = t("useClipboard:copySuccess"),
      errorMessage = t("useClipboard:copyError"),
    }: UseClipboardOptions = {},
  ) => {
    try {
      await navigator?.clipboard?.writeText(value || "");
      toast.success(successMessage);
    } catch {
      toast.error(errorMessage);
    }
  };

  return {
    copyToClipboard,
  };
};
